import React from 'react';
import { useParams, useHistory } from 'react-router-dom';
import IntentForm from './IntentFormComponent';
import { putIntent } from '../routing/routes';

const EditarIntent = ({ intents, setNotification, refreshData }) => {
	const { id } = useParams();
	const history = useHistory();
	const intent = intents.find((nodo) => nodo._id === id);
	function guardarIntent(nuevoIntent) {
		const data = { intent: nuevoIntent.intent, examples: nuevoIntent.examples };
		putIntent(nuevoIntent._id, data)
			.then(() => {
				refreshData();
				history.push('/training');
				setNotification('mIntent editado correctamente!');
			})
			.catch((error) => {
				setNotification('eOcurrió un error editando el intent!');
				console.error('Error:', error);
			});
	}
	if (intent) {
		return <IntentForm intent={intent} intents={intents} guardarIntent={guardarIntent} history={history} editing={true} />;
	} else {
		return <p>Loading...</p>;
	}
};

export default EditarIntent;
